import { Environment } from '@dice/app/types/env.type';
import { PROD_ENV_CONFIG } from '@dice/environments/prod/prod.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const PROD_MASTERDATA_ENV_CONFIG: Environment = {
  ...PROD_ENV_CONFIG,
  hostNames: ['dice-prod-masterdata.scapp-corp.swisscom.com', 'localhost:1000'],
  enableDebugInfo: false,
  isProduction: true,
  variant: 'dice-ui-prod-masterdata',
  logLevel: NgxLoggerLevel.OFF,

  wsEndpoint: `wss://buda-message-proxy-prod.scapp-corp.swisscom.com/`,
  wsEndpointForUCCP: `wss://buda-message-proxy-uccp-prod.scapp-corp.swisscom.com/`,
  budaStatisticsConsumerEndpoint: 'https://buda-message-proxy-prod.scapp-corp.swisscom.com/',
  budaStatisticsConsumerEndpointForUCCP: 'https://buda-message-proxy-uccp-prod-testing.scapp-corp.swisscom.com/',
  agentViewStatisticsConsumerEndpoint: `https://buda-message-proxy-agentview-prod.scapp-corp.swisscom.com/`,
  agentInfoStatisticsConsumerEndpoint: `https://buda-message-proxy-agentinfo-prod.scapp-corp.swisscom.com/`,
};
